import { FontSizes, FontWeights } from '@fluentui/react';
export var getStyles = function (props) {
    var theme = props.theme, isRead = props.isRead;
    return {
        itemDismissUndo: {
            padding: '12px 32px 12px 32px'
        },
        attentionText: {
            paddingTop: '4px',
            lineHeight: '24px',
            fontSize: FontSizes.size14,
            fontWeight: FontWeights.regular,
            marginRight: '16px'
        },
        readMoreText: {
            paddingTop: '4px',
            marginRight: '16px',
            lineHeight: '24px',
            fontSize: FontSizes.size14,
            fontWeight: FontWeights.regular
        },
        subjectText: {
            whiteSpace: 'normal',
            margin: '0 0 0 0 !important',
            fontSize: FontSizes.size14,
            fontWeight: isRead ? FontWeights.semibold : FontWeights.bold
        },
        senderName: {
            fontSize: FontSizes.size14,
            fontWeight: isRead ? FontWeights.regular : FontWeights.semibold
        },
        timeDelivered: {
            fontSize: FontSizes.size12,
            fontWeight: isRead ? FontWeights.regular : FontWeights.semibold
        },
        root: {
            position: 'relative',
            selectors: {
                '&:hover .contextButton, &:focus-within .contextButton': {
                    opacity: 1
                },
                '&:hover .timeHook, &:focus-within .timeHook': {
                    opacity: 0
                }
            }
        },
        rootButtonDiv: {
            alignSelf: 'stretch',
            border: '0px',
            height: 'auto',
            padding: '12px 32px 12px 12px',
            textAlign: 'left',
            selectors: {
                ':hover, :focus': {
                    backgroundColor: theme.palette.neutralLighter
                },
                ':active': {
                    backgroundColor: theme.palette.neutralLight
                },
                ':focus': {
                    outlineColor: theme.palette.neutralSecondary
                }
            }
        },
        messageBody: {
            overflow: 'hidden',
            wordWrap: 'break-word',
            lineHeight: '20px'
        },
        leftColumn: {
            width: '20px'
        },
        unreadIcon: {
            color: theme.palette.themePrimary,
            fontSize: '8px',
            marginTop: '6px'
        },
        timestampRow: {
            flexGrow: 1,
            justifyContent: 'space-between',
            position: 'relative',
            lineHeight: '20px'
        },
        senderImage: {
            margin: '4px 12px 0 0',
            maxWidth: '40px',
            selectors: {
                '.ms-Persona-details': {
                    display: 'none'
                }
            }
        },
        subjectContainer: {
            flex: 1
        },
        icon: {
            alignSelf: 'flex-top',
            fontSize: FontSizes.size24,
            margin: '0px 12px 0px 0px',
            paddingTop: '3px'
        },
        timeHook: [
            'timeHook',
            {
                opacity: 1
            }
        ],
        contextMenuContainer: {
            position: 'absolute',
            right: '3px',
            top: '3px'
        },
        contextButton: [
            'contextButton',
            {
                opacity: 0,
                color: theme.palette.neutralPrimary
            }
        ],
        additionalContent: {
            lineHeight: '20px'
        },
        buttonContent: [
            !isRead && {
                selectors: {
                    '::before': {
                        content: '""',
                        position: 'absolute',
                        backgroundColor: theme.palette.themePrimary,
                        top: 0,
                        left: 0,
                        width: 4,
                        height: '100%',
                        borderRadius: '2px'
                    }
                }
            }
        ],
        actionLinks: {
            display: 'flex'
        }
    };
};
//# sourceMappingURL=CoherenceNotificationItem.styles.js.map